// @flow

import { gql } from "@apollo/client";
import { graphql } from '@apollo/client/react/hoc';

const resetOrderVendorAssignmentForInHouseShipping: any = graphql(
  gql`
    mutation($orderId: ID!) {
      resetOrderVendorAssignmentForInHouseShipping(orderId: $orderId) {
        succeeded
      }
    }
  `,
  {
    name: "resetOrderVendorAssignmentForInHouseShipping"
  }
);

export default resetOrderVendorAssignmentForInHouseShipping;
